import script from "./DeleteList.vue?vue&type=script&setup=true&lang=js"
export * from "./DeleteList.vue?vue&type=script&setup=true&lang=js"

import "./DeleteList.vue?vue&type=style&index=0&id=82ba61dc&lang=scss"

const __exports__ = script;

export default __exports__